import React from 'react'
import styles from "./Contact.css";
import { AiOutlineMail,AiFillGithub, AiFillCodepenCircle, AiFillLinkedin,AiOutlineMobile } from 'react-icons/ai';


function Contact() {
    return (
        <div className="contact_container">
            <div className="contact_logos">
            <a href="#" target="_blank" className="a_l_"><AiFillGithub className="con_ic"/></a>
          
          <a href="#" target="_blank" className="a_l_"><AiFillCodepenCircle className="con_ic"/></a>
          
          <a href="#" target="_blank" className="a_l_"><AiFillLinkedin className="con_ic"/></a>

                <a href="#" className="a_l_"><AiOutlineMail className="con_ic"/></a>
                <a href="#" className="a_l_"><AiOutlineMobile className="con_ic"/></a>

                <h1 className="contact_ph"> Ph:XXXXXXXXX</h1>

            </div>
        </div>
    )
}

export default Contact
